enum NavigationDirection {
  Left,
  Right,
}

export { NavigationDirection };
